import { htmlFragmentToString } from '#shared'
import presetHTML5 from '@bbob/preset-html5'

const basePreset = presetHTML5

const SIZE_TAG_FONT_SIZE_MAPPING: Record<string, string> = {
  '1': '9px',
  '2': '10px',
  '3': '12px',
  '4': '15px',
  '5': '18px',
  '6': '22px',
  '7': '26px',
}

const HEADING_TAG_HTML_TAG_MAPPING: Record<string, string> = {
  '1': 'h2',
  '2': 'h3',
  '3': 'h4',
}

const HEADING_TAG_SIZE_MAPPING: Record<string, string> = {
  '1': '22px',
  '2': '18px',
  '3': '16px',
}

function attrsToValue(attrs: Record<string, unknown>) {
  const attrValues = Array.from(Object.values(attrs))
  if (!attrValues.length) return null
  return attrValues[0]
}

export const preset = basePreset.extend(tags => ({
  ...tags,

  size: node => {
    const nodeValue = attrsToValue(node.attrs ?? {})

    let size = '15px'
    if (typeof nodeValue === 'string' && SIZE_TAG_FONT_SIZE_MAPPING[nodeValue])
      size = SIZE_TAG_FONT_SIZE_MAPPING[nodeValue]

    return {
      tag: 'span',
      attrs: {
        style: `font-size: ${size}`,
      },
      content: node.content,
    }
  },

  heading: node => {
    const nodeValue = attrsToValue(node.attrs ?? {})

    let htmlTag = 'h3'
    let size = '18px'
    if (typeof nodeValue === 'string') {
      if (HEADING_TAG_HTML_TAG_MAPPING[nodeValue]) htmlTag = HEADING_TAG_HTML_TAG_MAPPING[nodeValue]
      if (HEADING_TAG_SIZE_MAPPING[nodeValue]) size = HEADING_TAG_SIZE_MAPPING[nodeValue]
    }

    return {
      tag: htmlTag,
      attrs: {
        style: `font-size: ${size}`,
      },
      content: node.content,
    }
  },

  center: node => ({
    tag: 'div',
    attrs: {
      style: 'text-align: center',
    },
    content: node.content,
  }),

  right: node => ({
    tag: 'div',
    attrs: {
      style: 'text-align: right',
    },
    content: node.content,
  }),

  justify: node => ({
    tag: 'div',
    attrs: {
      style: 'text-align: justify',
    },
    content: node.content,
  }),

  font: node => {
    const nodeValue = attrsToValue(node.attrs ?? {})

    return {
      tag: 'span',
      attrs: {
        style: `font-family: ${nodeValue}`,
      },
      content: node.content,
    }
  },

  ispoiler: node => ({
    tag: 'details',
    content: [
      {
        tag: 'summary',
        content: 'Show spoiler',
      },
      {
        tag: 'div',
        attrs: {
          style: 'padding: 5px',
        },
        content: node.content,
      },
    ],
  }),

  img: node => ({
    tag: 'img',
    attrs: {
      src: htmlFragmentToString(node.content),
    },
  }),
}))
